export class UserRequest {
    public email: string;
    public secureAuthUserName: string;
    public version: number;
}
